import Button from '@shared/components/core/button/CoreButton';
import { getManageSubscriptionsMailTo, getTrialUpgradeMailTo } from '@shared/constants/trials/FallbackEmailTemplate';
import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import { OrganizationModelLicenseKeys } from '@shared/models/organizations/OrganizationModelLicenses';
import { useTranslation } from 'react-i18next';

export default function OrgBillingRedirectErrorContent() {
    const { currentOrg } = useCurrentOrgDetailsFetching();
    const { t } = useTranslation();

    if (!currentOrg) return null;

    const getMailTo = () => {
        return currentOrg.hasLicense ? getManageSubscriptionsMailTo(currentOrg) : getTrialUpgradeMailTo(currentOrg);
    };

    return (
        <Button startIcon="externalLink" href={getMailTo()}>
            {t('common:upgrade')}
        </Button>
    );
}
